var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CallScreen',{attrs:{"title":"Roadside Assistance Advisor"}})}
var staticRenderFns = []

export { render, staticRenderFns }